export enum SignalGroupTypeEnum {
    PUBLIC      = 1,
    PRIVATE     = 2,
}
